.group {
  margin: 0;
  padding: 0;
  border: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.groupLegend {
  padding: 0 0 2px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--text-muted);
}

.checkboxRow {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 36px;
  font-size: 15px;
}
.checkbox {
  width: 18px;
  height: 18px;
  accent-color: var(--accent);
  margin: 0;
  flex-shrink: 0;
}
.checkboxDot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.checkboxLabel {
  flex-grow: 1;
}
.checkboxCount {
  font-size: 13px;
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

.chipRow {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.chip {
  height: 40px;
  padding: 0 14px;
  border-radius: var(--r-pill);
  font-size: 14px;
  font-weight: 600;
  background: var(--bg-panel);
  border: 1px solid var(--border-4);
  color: var(--text-primary);
}
.chipActive {
  border: 1.5px solid var(--accent);
  background: var(--bg-accent-tint-2);
  color: var(--accent-text-hover);
}

.seriesSelect {
  height: 44px;
  padding: 0 10px;
  border-radius: var(--r-10);
  border: 1px solid var(--border-4);
  background: var(--bg-panel);
  color: var(--text-primary);
  font-size: 15px;
}

.rail {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.railCard {
  background: var(--bg-panel);
  border-radius: var(--r-14);
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.railHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.railTitle {
  margin: 0;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 22px;
  text-transform: uppercase;
}
.resetButton {
  height: 36px;
  border: 0;
  background: transparent;
  font-size: 14px;
  font-weight: 600;
  color: var(--accent-text);
}
/* Dev/disabled fallback (SponsorAds.tsx) - shown instead of the real ad stack when
   window.__GOOGLE_ADS_ENABLED__ is unset, e.g. on localhost. */
.sponsorSlot {
  height: 250px;
  border-radius: var(--r-14);
  border: 1px dashed var(--border-dashed);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  font-size: 13px;
}

/* The 4 real Google ad slots, stacked in production order - see SponsorAds.tsx. Centered
   because this is also reused at the bottom of the mobile page (App.tsx), where the container
   is full-width rather than exactly 300px like the desktop rail. */
.adStack {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.adSlot {
  width: 300px;
  min-height: 250px;
}
